import ArticleLayout from '@/components/feature/ArticleLayout';
import { comparisonArticle } from '@/mocks/comparisonArticle';

export default function HipobuyVsKakobuySpreadsheet() {
  return <ArticleLayout article={comparisonArticle} slug="hipobuy-vs-kakobuy-spreadsheet" />;
}